module.exports = __webpack_public_path__ + "static/media/requestGGcard.c039c9ec.svg";